import React from 'react';
import {
  ButtonPriority,
  HoverStyles,
  PaddingModes,
  StatesButton,
  StatesButtonStates,
  ThreeDotsLoader,
} from '@wix/wix-ui-tpa/cssVars';
import {classes} from './StickyButton.st.css';
import {useGlobals} from '../../../../providers/globalPropsProvider';
import {AddToCartActionStatus} from '../../../../constants';

export enum StickyButtonDataHook {
  Root = 'StickyButtonDataHook.Root',
  LoadingIndicator = 'StickyButtonDataHook.LoadingIndicator',
}

export type StickyButtonProps = {
  text: string;
  onClick: () => void;
  disabled?: boolean;
};

export const StickyButton = ({text, onClick, disabled}: StickyButtonProps) => {
  const {addedToCartStatus, shouldShowAddToCartSuccessAnimation, resetAddedToCartStatus} = useGlobals();

  function getButtonState(): StatesButtonStates {
    /* istanbul ignore next: same as AddToCartButton - requires Quickview layout and complex async flow to test */
    if (shouldShowAddToCartSuccessAnimation && addedToCartStatus === AddToCartActionStatus.SUCCESSFUL) {
      return StatesButtonStates.SUCCESS;
    }
    return addedToCartStatus === AddToCartActionStatus.IN_PROGRESS
      ? StatesButtonStates.IN_PROGRESS
      : StatesButtonStates.IDLE;
  }

  return (
    <StatesButton
      disabled={disabled}
      state={getButtonState()}
      idleContent={text}
      inProgressContent={
        <div className={classes.threeDotsLoaderWrapper}>
          <ThreeDotsLoader className={classes.threeDotsLoader} data-hook={StickyButtonDataHook.LoadingIndicator} />
        </div>
      }
      onNotificationEnd={resetAddedToCartStatus}
      onClick={onClick}
      className={classes.root}
      fullWidth
      data-hook={StickyButtonDataHook.Root}
      hoverStyle={HoverStyles.underline}
      priority={ButtonPriority.primary}
      paddingMode={PaddingModes.explicitPaddings}
    />
  );
};
